import { useFeatureGatePlanSuggestion } from '@frameio/plan-management/feature-gate/hooks';

export function useIsSemanticSearchEnabled() {
  const semanticSuggestion = useFeatureGatePlanSuggestion('SEMANTIC_SEARCH');
  if (!semanticSuggestion) return false;
  return semanticSuggestion.includedInCurrentPlan;
}
